import * as React from "react"
import Layout from "../Components/Layout";

export default function Contact() {
  return (
    <main>
      <title>Contact - Fietsen Marijnissen :: Koop een fiets bij de man die hem ook vakkundig herstellen kan!</title>
      <Layout>
        <h1>Contact</h1>
        <p>Fietsen Marijnissen<br />
        Bredabaan 878<br />
        2930 Brasschaat<br />
        Maria-Ter-Heide<br />
        Tel: 03/663 02 39<br />
        Fax: 03/663 02 39<br />
        <a href="mailto:info@fietsenmarijnissen.be">info@fietsenmarijnissen.be</a></p>
      </Layout>
    </main>
  );
}
